module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Evelyn Anthony\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Evelyn Anthony is the pen name of Evelyn Ward-Thomas (1926–2108), a female British author who began writing in 1949. She gained considerable success with her historical novels—two of which were selected for the American Literary Guild—before winning huge acclaim for her espionage thrillers. Her book, "), _c('I', [_vm._v("The Occupying Power")]), _vm._v(", won the Yorkshire Post Fiction Prize, and her 1971 novel, "), _c('I', [_vm._v("The Tamarind Seed")]), _vm._v(", was made into a film starring Julie Andrews and Omar Sharif. Anthony’s books have been translated into nineteen languages.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/m3myzW/tc-custom/9781504032568.jpg?1692923905007",
      "alt": "This image is the cover for the book Valentina"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Valentina\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Valentina Grunowska is a countess, a great beauty, and an unwilling Polish agent—ordered by her brutal husband to spy on Napoleon’s plans for the attack on Russia. Colonel de Chavel is cold, contemptuous, and head of the French intelligence service."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Theirs seems like the least likely of love stories. But, as Napoleon’s army sweeps on towards Moscow, great events will throw them together—and pull them apart again. As the French face defeat and a starving retreat through the snow, Valentina must search desperately amongst the survivors for the man she loves.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Integrated Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0